<div class="home-empresa-container">
  <h1>Home Empresa</h1>
  <div class="content">
    <!-- Add your content here -->
  </div>
</div> 